var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crop-button"},[_c('div',{staticClass:"crop-button-icon",style:(_vm.plantStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }